/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Notificator from '@absolute/cloud-notify';
import '@absolute/cloud-notify/styles.css';
import toast from 'react-hot-toast';
import { NOTIFICATION_TYPES } from '#helpers/types.js';
import { useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import Portal from '#lib/components/portal.jsx';
import { Spinner } from '#lib/components/loading.jsx';
import { current } from 'tailwindcss/colors.js';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';

export function NotificatorChannel(props) {
    const {
        notificatorChannel,
        isTranslating,
        setIsTranslating,
        isPlacesCreating,
        setIsPlacesCreating,
        setIsLoadingPublish,
        onUpdateGuid,
        onUpdatePlaces,
        crud,
        edit,
        itineraryId: currentId
    } = props;
    const queryClient = useQueryClient();
    const [lastNotifyId, setLastNotifyId] = useState();
    const [lastType, setLastType] = useState(null);
    const [redirectLink, setRedirectLink] = useState('');
    // Counter to hide the translation loader only when both itinerary and theme are done translating
    const [loaderCounter, setLoaderCounter] = useState(0);

    const placesMutations = useAuthMutation({
        mutationFn: async (_, authHeaders) => {
            const res = await fetch(`${API_URL}/p/places/get`, {
                method: 'POST',
                headers: {
                    ...authHeaders,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    itineraryId: currentId
                })
            });
            return res.json();
        },
        onSuccess: (data) => {
            onUpdatePlaces(data.places);
        }
    });

    useEffect(() => {
        if (loaderCounter >= 2) {
            if (currentId === redirectLink.split('/').at(-1)) return;
            queryClient.invalidateQueries({ queryKey: ['itinerary'] });
            queryClient.invalidateQueries({ queryKey: ['itineraryOptions'] });
            queryClient.invalidateQueries({ queryKey: ['themes'] });
            setLoaderCounter(0);
            setIsTranslating(false);
        }
    }, [loaderCounter]);

    useEffect(() => {
        if (redirectLink) {
            toast.success(
                (t) => (
                    <Link to={redirectLink} onClick={() => toast.dismiss(t.id)}>
                        {_t.edit.translation.translationSuccess()}
                    </Link>
                ),
                { duration: 10000, icon: '🛫' }
            );
        }
    }, [redirectLink]);

    return (
        <Notificator channel={notificatorChannel}>
            {isTranslating && (
                <Portal>
                    <div className="absolute z-50 top-4 right-44">
                        <Spinner />
                    </div>
                </Portal>
            )}
            <Notificator.Button className="relative">
                {({ toRead }) => {
                    const type = toRead[0]?.data?.type;
                    const operationId = toRead[0]?.operationId;

                    if (lastNotifyId === operationId && type === lastType) return;
                    switch (type) {
                        case NOTIFICATION_TYPES.PLACE_ERROR:
                            setIsPlacesCreating(() => false);
                            break;
                        case NOTIFICATION_TYPES.PLACE_SUCCESS:
                            placesMutations.mutate();
                            if (isPlacesCreating) {
                                toast.success(_t.notifications.placesSuccessResponse());
                                setIsPlacesCreating(() => false);
                                /* const places = toRead[0]?.data?.data?.places.map((place) => {
                                    place.suggestions.sort((a, b) => a.id.localeCompare(b.id));
                                    place.info.sort((a, b) => a.id.localeCompare(b.id));
                                    return place;
                                });
                                onUpdatePlaces(places); */
                            }
                            break;
                        case NOTIFICATION_TYPES.PUBLISH_SUCCESS:
                            setIsLoadingPublish(() => false);
                            const data = toRead[0]?.data;
                            const newGuid = data?.itineraryGuid;
                            if (currentId === data?.itineraryId) onUpdateGuid(newGuid);
                            break;
                        case NOTIFICATION_TYPES.PUBLISH_FAILURE:
                            setIsLoadingPublish(() => false);
                            break;
                        case NOTIFICATION_TYPES.FLIGHT_UPDATE:
                            const { id: flightKey } = toRead[0]?.data;
                            const plan = crud.data.days
                                .flatMap((day, i) => day.plans.map((plan) => ({ ...plan, day: i })))
                                .find((plan) => plan?.flightKey === flightKey);
                            edit([`day-${plan?.day}`, plan.id], 'needsUpdate', true);
                            break;
                        case NOTIFICATION_TYPES.TRANSLATE_SUCCESS:
                            const { itineraryId } = toRead[0]?.data;
                            if (currentId !== itineraryId) setRedirectLink(`/manage/itinerary/edit/${itineraryId}`);
                            setLoaderCounter((prev) => prev + 1);
                            break;
                        case NOTIFICATION_TYPES.THEME_SUCCESS:
                            setLoaderCounter((prev) => prev + 1);
                            break;
                        case NOTIFICATION_TYPES.TRANSLATE_ERROR:
                            toast.error(_t.edit.translation.translationError());
                            setLoaderCounter((prev) => prev + 2);
                            break;
                        default:
                            // se non gestisco la notifica non setto il lastNotifyId
                            return;
                    }
                    setLastNotifyId(() => operationId);
                    setLastType(() => type);
                }}
            </Notificator.Button>
        </Notificator>
    );
}
